export const bucketsKeys = {
  root: () =>
    ({
      service: 'ace',
      scope: 'buckets',
    }) as const,

  buckets: (marketCountry: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'buckets',
      marketCountry,
    }) as const,

  bucket: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'bucket',
      id,
    }) as const,

  bucketApplications: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'bucket-applications',
      id,
    }) as const,

  workQueue: (clientID: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'work-queue',
      clientID,
    }) as const,

  applicationBucket: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'application-bucket',
      id,
    }) as const,

  applicationBucketRevisions: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'application-bucket-revisions',
      id,
    }) as const,

  bucketSummaries: () =>
    ({
      ...bucketsKeys.root(),
      entity: 'bucket-summaries',
    }) as const,

  assignee: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'assignee',
      id,
    }) as const,

  assingedApplications: (id: string) =>
    ({
      ...bucketsKeys.root(),
      entity: 'assigned-applications',
      id,
    }) as const,
};
